module.exports = __webpack_public_path__ + "static/media/status_grey.0cda15d0.svg";